/** @format */

import {ChartIds} from '../models/chartIds';
import {getSensorGroupByChartId} from '../helpers/sensors/getSensorGroupByChartId';
import {SensorGroupsList} from '../helpers/sensors/types';

const getSensorPrimaryValue = (chartId: ChartIds, sensorGroup?: SensorGroupsList): number => {
  const group = getSensorGroupByChartId(chartId);

  if (sensorGroup && sensorGroup[group]) {
    return sensorGroup[group].primary;
  }

  return 0;
};

export {getSensorPrimaryValue};
